export enum TG_BIND_STATUS {
  NOT_BIND = 0,
  BIND = 1,
}

export enum TG_NOTICE_SUBSCRIBE_STATUS {
  UNSUBSCRIBE = -1,
  SUBSCRIBED = 1,
}

export enum NOTICE_MODULE_STATUS {
  OPEN = '1',
  CLOSE = '2',
}

export enum NOTICE_MODULE_NEED_SAFETY {
  NOT_NEED = 0,
  NEED = 1,
}
